import { Box, CircularProgress, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { flowExecutions } from '../../../queries/flow-executions';
import GenericNodePanel from './GenericNodePanel';
import OutputControllerPanel from './OutputControllerPanel';
import TextGeneratorPanel from './TextGeneratorPanel';

interface Props {
  id: string;
  nodeType: string | null;
}

function NodeOutputPanel({ id, nodeType }: Props) {
  const { data, isLoading, isError } = useQuery(flowExecutions.nodeOutput(id));
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
        <CircularProgress size={18} />
      </Box>
    );
  }
  if (isError || !data) {
    return (
      <Typography variant='body2' color='error'>
        Failed to load node detail.
      </Typography>
    );
  }
  if (nodeType === 'commandTextNode') {
    return <TextGeneratorPanel data={data} />;
  }
  if (nodeType === 'outputController') {
    return <OutputControllerPanel data={data} />;
  }
  return <GenericNodePanel data={data} />;
}

export default NodeOutputPanel;
